export default __webpack_public_path__ + "static/media/group-7677.3ce46eac.svg";